import { render, staticRenderFns } from "./TabSamTermsList.vue?vue&type=template&id=23627c9d&scoped=true&"
import script from "./TabSamTermsList.vue?vue&type=script&lang=js&"
export * from "./TabSamTermsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23627c9d",
  null
  
)

export default component.exports